<button
  odxButton
  variant="secondary"
  (click)="buttonClicked.emit()"
  [odxTooltip]="isExtended() ? tooltipTextCollapseItem : tooltipTextExtendItem"
>
  @if (isExtended()) {
    <odx-icon name="chevron-right" size="medium"></odx-icon>
  } @else {
    <odx-icon name="chevron-left" size="medium"></odx-icon>
  }
</button>
